export const datalayerConstants = {
    BRAND: "Rightship",
    CURRENCY: "$",
};
